import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.00005 4.9002V3.7002C2.00005 2.90455 2.31612 2.14148 2.87873 1.57888C3.44134 1.01627 4.2044 0.700195 5.00005 0.700195C5.7957 0.700195 6.55876 1.01627 7.12137 1.57888C7.68398 2.14148 8.00005 2.90455 8.00005 3.7002V4.9002C8.31831 4.9002 8.62353 5.02662 8.84858 5.25167C9.07362 5.47671 9.20005 5.78194 9.20005 6.1002V9.1002C9.20005 9.41846 9.07362 9.72368 8.84858 9.94872C8.62353 10.1738 8.31831 10.3002 8.00005 10.3002H2.00005C1.68179 10.3002 1.37656 10.1738 1.15152 9.94872C0.926477 9.72368 0.800049 9.41846 0.800049 9.1002V6.1002C0.800049 5.78194 0.926477 5.47671 1.15152 5.25167C1.37656 5.02662 1.68179 4.9002 2.00005 4.9002ZM6.80005 3.7002V4.9002H3.20005V3.7002C3.20005 3.22281 3.38969 2.76497 3.72726 2.4274C4.06482 2.08984 4.52266 1.9002 5.00005 1.9002C5.47744 1.9002 5.93528 2.08984 6.27284 2.4274C6.61041 2.76497 6.80005 3.22281 6.80005 3.7002Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}